export default __webpack_public_path__ + "static/media/partner-logo-sportmultimedia.5f545b0f.png";